import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Card from '@components/Card';
import Subtitle from '@components/Subtitle';
import InputWithCounter from '@components/InputWithCounter';

const Container = styled.div`
  margin-top: 20px;
`;

const StyledSubtitle = styled(Subtitle)`
  margin-left: ${({ theme }) => theme.spacing(8)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  h3 {
    margin-bottom: 0;
  }
`;

const Description = styled.span`
  display: block;
  ${({ theme }) => theme.fontFamily.secondaryFont.smallRegular};
  margin-left: ${({ theme }) => theme.spacing(8)};
  padding-bottom: ${({ theme }) => theme.spacing(2)};
`;

function Notes({ description, subtitle, notes, label, onChange, placeholder }) {
  return (
    <Container>
      <StyledSubtitle label={subtitle} separator={false} />
      {description && <Description>{description}</Description>}
      <Card direction="column">
        <InputWithCounter
          elementId="product_config_clarification"
          value={notes}
          label={label}
          type="text"
          isValid
          block
          onChange={onChange}
          maxCounter={250}
          placeholder={placeholder}
        />
      </Card>
    </Container>
  );
}

Notes.propTypes = {
  description: PropTypes.string,
  subtitle: PropTypes.string.isRequired,
  label: PropTypes.string,
  notes: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
};

export default Notes;
